import React, { forwardRef } from 'react';
import { node, func, bool, string } from 'prop-types';
import classNames from 'classnames';
import { ReactComponent as IconChevronDown } from '../../assets/icons/chevron-down.svg';

import css from './ChevronButton.module.css';

const ChevronButton = forwardRef(
  (
    {
      children,
      onClick,
      isExpanded = false,
      className,
      ariaLabel,
      testId,

      ...props
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        className={classNames(css.chevronButton, className)}
        onClick={onClick}
        aria-expanded={isExpanded}
        aria-label={ariaLabel}
        data-testId={testId}
        {...props}
      >
        <div className={css.buttonContent}>
          <div className={css.contentWrapper}>{children}</div>
          <div className={css.chevronWrapper}>
            <IconChevronDown
              className={classNames(css.chevronIcon, {
                [css.chevronExpanded]: isExpanded,
              })}
            />
          </div>
        </div>
      </button>
    );
  }
);

ChevronButton.displayName = 'ChevronButton';

ChevronButton.defaultProps = {
  children: null,
  isExpanded: false,
  className: '',
  ariaLabel: '',
  testId: '',
};

ChevronButton.propTypes = {
  children: node,
  onClick: func.isRequired,
  isExpanded: bool,
  className: string,
  ariaLabel: string,
  testId: string,
};

export default ChevronButton;
